<template>
  <div id="page-donations">
    <h5 class="m-4 page-header"> >> {{ $t('DONATION.DONATIONS') }}</h5>

    <Confirm
      :title="$t('DONATION.DELETE_CONFIRM_TITLE')"
      :message="$t('DONATION.DELETE_CONFIRM_MESSAGE')"
      ref="delete-form-confirm"
      type="success"
      @confirm="delete_form_confirmed"
    />


    <DonationEditorModal
      :item="selected_item"
      ref="form-editor-modal"
      @updated="form_updated"
      @created="form_created"
    />

    <memlist-card>

      <div class="ml-tabs">
        <div class="ml-tabs-header">
          <button
            type="button"
            v-for="(tab, i) in tabs"
            :key="i"
            :class="['ml-tab-button', active_tab === i ? 'active' : '']"
            @click="active_tab = i"
          >
            {{ $t(tab.label) }}
          </button>
        </div>

        <div class="ml-tabs-body">
          <div v-show="active_tab === 0">
            <DonationsTable
              :items="items"
              @delete_form_clicked="delete_form_clicked"
              @select_form_clicked="select_form_clicked"
              @create_form_clicked="create_form_clicked"
            />
          </div>
          <div v-show="active_tab === 1">
            <SubscriptionPaymentsTable 

            />
          </div>
          <div v-show="active_tab === 2">
            <ShopOrderTable
              ref="shop_orders_table"
              @shop_order_selected="shop_order_selected"
            />
          </div>
        </div>
      </div>
    </memlist-card>
  
  </div>
</template>



<script>
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { mapGetters } from 'vuex';

import axios from 'axios';

import DonationsTable from '@/view/pages/ml/donation/DonationsTable.vue';
import DonationEditorModal from '@/view/pages/ml/donation/DonationEditorModal.vue';
import SubscriptionPaymentsTable from '@/view/pages/ml/subscriptions/SubscriptionPaymentsTable.vue';
import ShopOrderTable from './shop_order/ShopOrderTable.vue';

export default {
  name: 'DonationsPage',
  mixins: [ toasts ],
  components: {
    DonationsTable,
    DonationEditorModal,
    SubscriptionPaymentsTable,
    ShopOrderTable,
  },
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'periods'])
  },
  mounted() {
    this.load_forms();
  },
  data() {
    return {
      selected_item: {},
      items: [],
      active_tab: 0,
      tabs: [
        { label: 'DONATION.DONATIONS' },
        { label: 'SUBSCRIPTION.SUBSCRIPTIONS' },
        { label: 'DONATION.PAYMENTS' },
      ]
    };
  },
  watch: {
    currentCompanyId(newValue, oldvalue) {
      if (newValue) {
        
      }
    },
    currentPeriodId(newValue, oldValue) {
      if (this.currentCompanyId) {

      }
    }
  },
  methods: {

    shop_order_selected() {},

    create_form_clicked() {
      this.selected_item = { 
        texts: {
          success_header: 'Lyckad registrering',
          success_text: 'Tack för att du registrerade dig. Kontrollera inkorgen för att bekräfta din e-postadress.',
          failure_header: 'Registrering misslyckades',
          failure_text: 'Något gick fel. Vänligen försök igen senare.'
        } 
      };

      this.$nextTick(()=>{
        this.$refs['form-editor-modal'].show();
      });
    },

    form_updated(item) {
      const index = this.items.findIndex(i => i.id === item.id);

      if (index > -1) {
        this.items[index] = item;
      }

      this.items = [...this.items];
    },

    form_created(item) {
      this.items.push(item);
    },

    delete_form_clicked(id) {
      this.selected_item.id = id;

      this.$refs['delete-form-confirm'].show();
    },

    async select_form_clicked(id) {
      this.selected_item = this.items.find(item => item.id === id);

      const item = await axios.get(`/form/admin/${id}`);

      this.selected_item = item.data;

      this.$nextTick(()=>{
        this.$refs['form-editor-modal'].show();
      });
    },

    async delete_form_confirmed() {
      
      try {
        const response = await axios.delete(`/form/${this.selected_item.id}`);

        if (response.status === 204) {
          this.toastr('success', this.$t('COMMON.OK') , this.$t('DONATION.DELETED'));

          this.items = this.items.filter(item => item.id !== this.selected_item.id);

          return;
        }
      }
      catch (err) {
        console.error('delete_form_confirmed error', err);
      }

      this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('DONATION.UNABLE_DELETE'));

    },

    async load_forms() {
      
      try {
        const response = await axios.get(`/form?type=DONATION`);

        if (response.status === 200) {
          this.items = response.data;

          return;
        }
      }
      catch (err) {
        console.error('load_forms error', err);
      }

      this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('DONATION.UNABLE_LIST'));

    },
  }
};
</script>
<style lang="scss" scoped>



</style>
